define('NetSuite.SuiteCommCPQ.Main.View.Head', [
        'netsuite_suitecommcpq_main_css.tpl',
        'Utils', 'Backbone', 'jQuery', 'underscore', 'NetSuite.SuiteCommCPQ.Main.Configuration',
        'NetSuite.SuiteCommCPQ.Main.Core', 'NetSuite.SuiteCommCPQ.Main.Debug'
    ],
    function(netsuite_suitecommcpq_main_css_tpl, Utils, Backbone, jQuery, _, Configuration, Core, Debugger) {
        'use strict';
        Debugger.log('VCPQ','< NetSuite.SuiteCommCPQ.Main.View.Head >');
        var hideQuickViewDesc = Configuration.get('hideQuickViewDesc'),
            hideFullViewDesc =  Configuration.get('hideFullViewDesc'),
            customStylesheetURL = Configuration.get('customStyles'),
            startNewTab =  Configuration.get('startNewTab'),
            hideMiniCartItemDescription = 'div.header-mini-cart-item-cell-details div.transaction-line-views-options-selected-content div[name="Description"] { display: none; }',
            hideNormalCartItemDescription = 'div.cart-detailed-body div.cart-lines-options div[name="Description"] { display: none; }';
        var vcpqCss = {
            style: '',
            add: function (style) {
                this.style += style;
            },
            set: function (style) {
                this.style = style;
            },
            fire: function () {
                jQuery('#vcpq-sc-style').text(this.style);
            }
        };
        // @class NetSuite.SuiteCommCPQ.Main.View.Head @extends Backbone.View
        return Backbone.View.extend({
            template: netsuite_suitecommcpq_main_css_tpl,
            initialize: function(options) {
                Debugger.log('VCPQ','ViewHead : init');
                Core.initCPQContainer(startNewTab);
                if (customStylesheetURL)
                    addCustomStylesheet(customStylesheetURL);
            },
            events: {},
            bindings: {},
            childViews: {
            },
            loaded: function loaded() {},
            //@method getContext @return NetSuite.SuiteCommCPQ.Main.View.Head.Context
            getContext: function getContext() {
                //@class VT.VGen.VModule.View.Context
                if (hideFullViewDesc)
                    vcpqCss.add(hideNormalCartItemDescription);
                if (hideQuickViewDesc)
                    vcpqCss.add(hideMiniCartItemDescription);
                return {};
            },
            _init: function() {
                Core.setGlobal('applyStyles', function () {
                    vcpqCss.fire();
                });
                window.vcpqCss = window.vcpqCss || vcpqCss;
            }
        });
        //
        function addCustomStylesheet(url) {
            //
            var style = jQuery('<link rel="stylesheet" type="text/css">');
            style.prop('href', url);
            style.appendTo('head');
        }
    });
